export default __webpack_public_path__ + "static/media/bg-hotel.1f63a728.jpg";